import { type RegisteredComponent, isEditing } from "@builder.io/sdk-react";

import { SPENDER_BLOCK_NAME } from "~/routes/fsastore-spender/spender-page";

/**
 * COM-474 marker: makes the catch-all load the spender data that the page's
 * spender blocks (ticker, chip row, grid, cart) render from. It renders
 * nothing itself, only carries inputs and an editor placeholder.
 */
const FsaSpenderPage = ({
  attributes,
}: {
  attributes?: Record<string, unknown>;
  persistBalance?: boolean;
}) => (
  <div data-testid="spender-page-marker-root" {...attributes}>
    {isEditing() && (
      <p
        data-testid="spender-page-marker-message"
        className="border border-dashed p-4 text-sm"
      >
        FSA Spender data. Required for the spender ticker, chip row, grid and
        cart blocks, which render on any FSA page that includes this block.
        Save, then reload the preview.
      </p>
    )}
  </div>
);

export const FsaSpenderPageDefinition = {
  component: FsaSpenderPage,
  name: SPENDER_BLOCK_NAME,
  friendlyName: "FSA Spender page (FSA only)",
  noWrap: true,
  canHaveChildren: false,
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/shopping-cart.svg",
  inputs: [
    {
      name: "persistBalance",
      type: "boolean",
      defaultValue: false,
      helperText:
        "Keep the shopper's entered balance across visits (local storage).",
    },
  ],
} satisfies RegisteredComponent;

export default FsaSpenderPage;
